module.exports = __webpack_public_path__ + "img/img12.243550c9.svg";